import { enums } from "../../../shim/jsbridge";

const { yaraRepoPreferences, yaraRepoSourceFilter } = enums || {};

export const YARA_REPO_TOOLTIP_MESSAGES = Object.freeze({
  mandatory_fields: "Please fill out mandatory fields before submitting.",
  full_manual_preferences:
    "You will have to manually import and update rulesets from the repository.",
  manual_import_auto_update_preferences:
    "You will have to manually import rulesets, but imported ones will automatically be updated.",
  full_auto_preferences:
    "Rulesets from the repository will automatically be imported and updated.",
  api_token: "API Token is needed for private repositories.",
  no_changes: "No changes have been made.",
  delete_disabled_system:
    "Not possible to remove repositories implemented by Spectra Analyze.",
  delete_disabled_permissions:
    "You don't have permission to remove this repository.",
  edit_field_disabled:
    "Not possible to edit this field as it’s a repository implemented by Spectra Analyze."
});

export const YARA_REPO_GRID_FILTER_MENU_ITEMS = {
  ALL: {
    value: yaraRepoSourceFilter.ALL,
    label: "All Repositories"
  },
  USER: {
    value: yaraRepoSourceFilter.USER,
    label: "User Repositories"
  },
  SYSTEM: {
    value: yaraRepoSourceFilter.SYSTEM,
    label: "Spectra Analyze Repositories"
  }
};

export const YARA_REPO_PREFERENCES = {
  [yaraRepoPreferences.FULL_MANUAL]: {
    value: "manual",
    label: "Manual",
    tooltipMsg: YARA_REPO_TOOLTIP_MESSAGES.full_manual_preferences,
    enum_value: yaraRepoPreferences.FULL_MANUAL
  },
  [yaraRepoPreferences.AUTO_UPDATE]: {
    value: "auto_update",
    label: "Auto-Update",
    tooltipMsg:
      YARA_REPO_TOOLTIP_MESSAGES.manual_import_auto_update_preferences,
    enum_value: yaraRepoPreferences.AUTO_UPDATE
  },
  [yaraRepoPreferences.FULL_AUTO]: {
    value: "auto",
    label: "Auto-Update & Auto-Import",
    tooltipMsg: YARA_REPO_TOOLTIP_MESSAGES.full_auto_preferences,
    enum_value: yaraRepoPreferences.FULL_AUTO
  }
};

export const YARA_REPO_FORM_FIELDS: {
  [key: string]: {
    name: string;
    type: string;
    label: string;
    tooltipText?: string;
    required?: boolean;
  };
} = {
  URL: {
    name: "url",
    type: "text",
    label: "Repository URL",
    required: true
  },
  NAME: {
    name: "name",
    type: "text",
    label: "Repository Name",
    required: true
  },
  SOURCE_BRANCH: {
    name: "source_branch",
    type: "text",
    label: "Source Branch",
    required: false,
    tooltipText:
      "If not specified, default repository branch will be used (e.g. main or master)."
  },
  API_TOKEN: {
    name: "api_token",
    type: "password",
    label: "API Token"
  },
  IMPORT_UPDATE_PREFERENCES: {
    name: "import_update_preferences",
    type: "radio",
    label: "Update/Import Preferences"
  }
};

export const YARA_REPO_UPDATE_DIALOG_TYPES = {
  ADD: "add",
  EDIT: "edit",
  DELETE: "delete"
};

export const YARA_REPO_DIALOG_ITEMS = {
  [YARA_REPO_UPDATE_DIALOG_TYPES.ADD]: {
    title: "Add YARA Repository"
  },
  [YARA_REPO_UPDATE_DIALOG_TYPES.EDIT]: {
    title: "Edit YARA Repository"
  }
};

export const DEFAULT_GRID_PAGE_SELECTIONS = [
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "50", value: "50" }
];

export const DEFAULT_GRID_PAGE_SIZE = 10;

export const YARA_REPO_DROPDOWN_SECTIONS_LABELS = {
  USER: "User Repositories",
  SPECTRA_ANALYZE: "Spectra Analyze Repositories"
};
